import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { ArticulosGeneral, CategoriasWebMenu, EcommerceGenericoService, HistorialPedidos, PedidosMmaxEccomerce, PromocionesEccomerce, ResultadosDeBusquedaInterface, SucursalEcommerce, TurnosRetiroEccomerce, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuMmaxInterface } from './etc/mmax-menu.interface'
import { MyNavigator } from './etc/navegador-class';
import { PCNavigator } from './etc/pcmode-class';
import { CheckboxSubcategoria } from './etc/categoria-checkbox.interface';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../app/core/auth/auth.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class MarianomGeneral {
  private turnoselecionado: TurnosRetiroEccomerce;
  desplegado: boolean = false;
  rutas: MenuMmaxInterface[] = [];
  desplegadocat: boolean;
  desplegadousa: boolean = false;
  desplegadosearch: boolean;
  articuloEnPopUp: ArticulosGeneral;
  navigator: MyNavigator;
  email: any;
  whitelist: Map<string, boolean> = new Map();
  slides: any;
  selectorName: string;
  busqueda: string;
  refreshProducts: boolean;
  retiroEnvio: number;
  automaticSlide: any;
  ocultarSideBarBusqueda: boolean = true;
  ocultarMenuProductos: boolean = false;
  ocultarMenuOfertas: boolean = false;
  ocultarMenuMarcas: boolean = false;
  ocultarMenuCompras: boolean = false;
  ocultarMenuSucursales: boolean = false;
  ocultarMenuAyuda: boolean = false;
  private menuActivoNombre: string = '';

  private mensajeModalSubject = new BehaviorSubject<{ title: string, message: string }>(null);
  mensajeModal$ = this.mensajeModalSubject.asObservable();

  constructor(private serv: EcommerceGenericoService, private router: Router, private modal: ModalService, private httpClient: HttpClient, private authService: AuthService) {

    this.modal.onModalOpened.subscribe((id: string) => {
      if (id !== 'spinner-modal' && id !== 'modal-error') {
        this.cerrarUI();
      }
    });

    setTimeout(() => {
      this.resizeEvent();
    }, 1000);
  }

  initMaster() {
    this.whitelist.set('cerrarpedidoweb', true);
    this.whitelist.set('ordenpagoweb', true);
    this.whitelist.set('planesmediosweb', true);
    //this.whitelist.set('pedidoweb', true);
    //this.whitelist.set('itempedidoweb',false);
    //this.whitelist.set('renew',false);
    this.serv.initmaster.toPromise().then((respuesta) => {
      this.ocultarMenuProductos = this.serv.ocultarMenuProductos;
      this.ocultarMenuOfertas = this.serv.ocultarMenuOfertas;
      this.ocultarMenuMarcas = this.serv.ocultarMenuMarcas;
      this.ocultarMenuCompras = this.serv.ocultarMenuCompras;
      this.ocultarMenuSucursales = this.serv.ocultarMenuSucursales;
      this.ocultarMenuAyuda = this.serv.ocultarMenuAyuda;
      this.rutas = [
        {
          nombre: 'Productos',
          ruta: 'busqueda',
          activo: false,
          oculto: this.ocultarMenuProductos
        },
        {
          nombre: 'Ofertas y Promociones',
          ruta: 'ofertas',
          activo: false,
          oculto: this.ocultarMenuOfertas
        },
        {
          nombre: 'Mis Compras',
          ruta: 'historial',
          activo: false,
          oculto: this.ocultarMenuCompras
        },
        {
          nombre: 'Marcas Destacadas',
          ruta: 'marcas',
          activo: false,
          oculto: this.ocultarMenuMarcas
        },
        {
          nombre: 'Sucursales',
          ruta: 'sucursales',
          activo: false,
          oculto: this.ocultarMenuSucursales
        },
        {
          nombre: 'Ayuda',
          ruta: 'ayudas',
          activo: false,
          oculto: this.ocultarMenuAyuda
        },
      ];

      // Después de inicializar las rutas, determinar el menú activo
      this.rutas.forEach(ruta => {
        if (ruta.ruta === this.router.url.substring(1)) {
          // ruta.activo = true;
          this.menuActivoNombre = ruta.nombre;
        }
      });

      return respuesta;
    }).catch((error: any) => {
      console.error("Promise rejected with error:", error);
    });
  }

  llamarSpinner() {
    this.modal.open('spinner-modal');
  }

  cerrarSpinner() {
    this.modal.close('spinner-modal');
  }

  private resizeEvent() {
    this.navigator = new PCNavigator(this.router, this);
  }

  opArtConModal() {
    if (this.serv.getCantidadTotal() == 0) {
      this.modal.open('articulo-pc-mmax-modal');

      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      setTimeout(() => {
        this.modal.close('articulo-pc-mmax-modal');
      }, 3000);
    }
  }

  isloged() {
    if (this.serv.getUser()) {
      return true;
    }
    else {
      return false;
    }
  }

  abrirModalLogin() {
    this.modal.open('login-modal-1');
  }

  async loginok() {
    this.authService.setLogueado(true);
    this.router.navigate(['']);
    this.modal.closeAll();
  }

  forceError(arg0: string) {
    this.router.navigate[arg0];
  }

  salirylimpiar(route: ActivatedRoute) {

    this.serv.limpiarysalir();
    this.authService.logout();
    if (this.serv.returnObligaLogin() === true || this.serv.returnObligaLogin() === undefined || this.serv.returnObligaLogin() === null)
      this.router.navigate(['/login']);
    else
      this.router.navigate(['']);
  }

  marcarCarroConRemplazo(event: CheckboxSubcategoria) {
    this.serv.getCarrito().forEach(k => {
      k.setRemplazo(Number.parseInt(event.id));
      k.getRemplazos().forEach(k => {
        if (k.modo === event.id) {
          k.activo = true;
        }
        else {
          k.activo = false;
        }
      });
    })
  }

  marcarFaltantesConRemplazo(event: CheckboxSubcategoria) {
    this.serv.getCarrito().forEach(
      articuloCarro => {
        if (articuloCarro.getRemplazo() == -1) {
          articuloCarro.setRemplazo(Number.parseInt(event.id));
          articuloCarro.getRemplazos().forEach(
            remplazo => {
              if (remplazo.modo === event.id) {
                remplazo.activo = true;
              }
              else {
                remplazo.activo = false;
              }
            }
          );
        }
      }
    );
  }

  gotoURL(url: string, route: ActivatedRoute) {
    this.router.navigate([url], { relativeTo: route });
  }

  goLandPage() {
    this.rutas.forEach(k => {
      k.activo = false;
    });
  }

  abrirTurnos() {
    this.modal.open('turnos-mmax-modal-1')
  }

  setSelectorName(nombre) {
    this.selectorName = nombre;
  }

  returnSelectorName() {
    return this.selectorName;
  }


  activatethis(menuElegido: MenuMmaxInterface) {
    this.rutas.forEach(menu => {
      if (menu.nombre === menuElegido.nombre) {
        menu.activo = true;
        this.menuActivoNombre = menuElegido.nombre
        this.cerrarUI();
      }
      else {
        menu.activo = false;
      }
    });
  }

  articuloAmostrar(articulo: ArticulosGeneral) {
    this.articuloEnPopUp = articulo;
  }

  getArticuloEnmodal() {
    return this.articuloEnPopUp;
  }

  setRetiroEnvio(modo: number) {
    this.retiroEnvio = modo;
  }

  returnRetiroEnvio() {
    return this.retiroEnvio;
  }

  prayandpaid() {
    let usaTurno = true;
    this.serv.returnUsaTurnos().subscribe(data => {
      if (data == 'N') {
        usaTurno = false;
      }
    });

    let datosEnvio = this.serv.getDatosEnvio();
    if (usaTurno) {
      return this.serv.cerrarPedido(this.turnoselecionado.dia, this.turnoselecionado.horainicio, this.turnoselecionado.fecha, this.turnoselecionado.modo, datosEnvio?.ciudad, datosEnvio?.barrio, datosEnvio?.calle, datosEnvio?.numero)
    } else {
      return this.serv.cerrarPedido(1, 900, moment().format('YYYY-MM-DDTHH:mm:ssZ'), this.returnRetiroEnvio(), datosEnvio?.ciudad, datosEnvio?.barrio, datosEnvio?.calle, datosEnvio?.numero)
    }
  }

  inciarbusqueda(event: string) {
    this.serv.iniciarbusqueda(event);
    this.busqueda = event;
    this.refreshProducts = false;
  }

  returnBusqueda() {
    return this.busqueda;
  }

  goToProducts(bool) {
    this.refreshProducts = bool;
  }

  returnRefreshProducts() {
    return this.refreshProducts;
  }

  setTurno(turno: TurnosRetiroEccomerce) {
    this.turnoselecionado = turno;
  }

  ultimoTurno() {
    return this.turnoselecionado;
  }

  cerrarUI() {
    this.desplegadocat = false;
    this.desplegado = false;
    this.desplegadousa = false;
    this.desplegadosearch = false;
  }

  desplegaryCerrar(arg0: boolean) {
    if (arg0) this.modal.closeAll();
    this.desplegadocat = arg0;
    this.desplegado = false;
    this.desplegadousa = false;
    this.desplegadosearch = false;
  }

  abrircerrarCart(arg0: boolean) {
    if (arg0) this.modal.closeAll();
    this.desplegadocat = false;
    this.desplegado = arg0;
    this.desplegadousa = false;
    this.desplegadosearch = false;
  }

  desplegaryCerrarusu(arg0: boolean) {
    if (arg0) this.modal.closeAll();
    this.desplegadocat = false;
    this.desplegado = false;
    this.desplegadousa = arg0;
    this.desplegadosearch = false;
  }

  abriryCerrrarSearch(arg0: boolean) {
    if (arg0) this.modal.closeAll();
    this.desplegadocat = false;
    this.desplegado = false;
    this.desplegadousa = false;
    this.desplegadosearch = arg0;
  }

  toggleSideBarBusqueda() {
    this.ocultarSideBarBusqueda = !this.ocultarSideBarBusqueda;
  }

  getOcultarSideBarBusqueda() {
    return this.ocultarSideBarBusqueda
  }

  getMenuActivoNombre() {
    return this.menuActivoNombre;
  }

  setMenuActivoNombre(menuActivoNombre: string) {
    this.menuActivoNombre = menuActivoNombre;
  }

  abrirMensaje(title: string, message: string) {
    this.mensajeModalSubject.next({ title, message });
    this.modal.open('modal-mensaje');
  }
}
